import * as React from 'react';
import Icon from './Icons';

const Loading = () =>  {
  return (
    <div className="loading">
      <Icon.Spinner/>
      Loading...
    </div>
  )
};

const Error = ({ message }) => {
  return (
    <div className="error">
      <Icon.Error/>
      <h4>{ message }</h4>
    </div>
  )
};

export {
  Loading,
  Error,
}



// WEBPACK FOOTER //
// ./src/components/static/Indicators.js